import client from "utils/api";
import store from 'utils/store'
import analytics from 'utils/analytics'

function createAdventure(account_id, name, stories, isPublic=true){
  return client().post("/accounts/"+account_id+"/adventures", {name, stories, isPublic})
    .then((response) => {
      analytics.track("create_adventure")
      return response.data
    })
    .catch(e => {
      //console.log("==>", e.response)
      store.dispatch({type:"ADD_TOAST", id:"connection-problem", message:"There was a problem connecting to the server."})

    });
}
function updateAdventure(account_id, adventure, stories){
  return client().put("/accounts/"+account_id+"/adventures/"+adventure.id, {name:adventure.name, stories, isPublic:adventure.isPublic})
    .then((response) => {
      analytics.track("update_adventure")
      return response.data
    })
    .catch(e => {
      //console.log("==>", e.response)
      store.dispatch({type:"ADD_TOAST", id:"connection-problem", message:"There was a problem connecting to the server."})

    });
}


export default {
  createAdventure,
  updateAdventure
}



// WEBPACK FOOTER //
// ./src/components/account_page/stories/adventure/api.js